export default "__VITE_ASSET__DDPOHAca__"